export enum FieldTypeFormat {
    PHONE_NUMBER = 'PHONE_NUMBER',
    INTERNATIONAL_PHONE_NUMBER = 'INTERNATIONAL_PHONE_NUMBER',
    US_SOCIAL_SECURITY_NUMBER = 'US_SOCIAL_SECURITY_NUMBER',
    US_EMPLOYER_IDENTIFICATION_NUMBER = 'US_EMPLOYER_IDENTIFICATION_NUMBER',
}
